export const landlordPayouts = [
    {
      date: "09/01 06:30",
      landlordName: "John Edwin",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Daniel River ",
      propertyName: "UNIT-015 Riverside Gardens",
      amountPaid: "UGX 950,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Processing",
      referenceId: "TX-9872314567"
    },
    {
      date: "02/04 07:00",
      landlordName: "Michael Brown",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Sarah Johnson",
      propertyName: "UNIT-004 Greenview Flats",
      amountPaid: "UGX 150,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Paid",
      referenceId: "TX-9872314567"
    },
    {
     date: "11/17 06:30",
      landlordName: "D chandimal",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Kumar sangakara",
      propertyName: "UNIT-004 Riverside Gardens",
      amountPaid: "UGX 1950,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Failed",
      referenceId: "TX-9872314567"
    },
    {
      date: "05/22 09:45",
      landlordName: "John wick",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Michal Jackson",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 450,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Failed",
      referenceId: "TX-9872314567"
    },
    {
      date: "02/04 06:00",
      landlordName: "Michel Stack",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Daniel is a River ",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 710,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Failed",
      referenceId: "TX-9872314567"
    },
    {
      date: "04/02 02:30",
      landlordName: "Kane williams",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Sarah Johnson",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 200,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Paid",
      referenceId: "TX-9872314567"
    },
    {
      date: "07/13 04:17",
      landlordName: "Steve Smith",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Daniel River ",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 110,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Paid",
      referenceId: "TX-9872314567"
    },
    {
      date: "02/04 06:30",
      landlordName: "John Edwin",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "John cena",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 950,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Processing",
      referenceId: "TX-9872314567"
    },
    {
      date: "02/04 06:30",
      landlordName: "John Edwin",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Daniel River",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 950,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Paid",
      referenceId: "TX-9872314567"
    },
    {
      date: "02/04 06:30",
      landlordName: "John Edwin",
      bank: "Equity Bank - 045***3344",
      grossAmount: "120,000 UGX",
      commission: "12,000 UGX",
      tenantName: "Daniel is a River ",
      propertyName: "UNIT-OO4 @ Greenview Flats",
      amountPaid: "UGX 050,000",
      paidTenant: "LKR 500000",
      amountMobile: "LKR 500000",
      channel: "Bank",
      unitProperty: "005 Land",
      netAmount: "108,000 UGX",
      status: "Paid",
      referenceId: "PAY20250510143001",
      amountLandloard: "UGX",
      platformCommission: "UGX",
      paymentMethod: "Mobile Money",
      reference: "1234567890",
      paymentMethod: "Card",
      status: "Processing",
      referenceId: "TX-9872314567"
    },
  ];
  
export const SupportLogsData = [
  {
    key: "1",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "completed",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "maintenance",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "2",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "in_progress",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "legal",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "3",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "completed",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "tax",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "4",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "completed",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "maintenance",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "5",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "in_progress",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "legal",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "6",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "completed",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "tax",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "7",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "completed",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "maintenance",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
  {
    key: "8",
    date: "02/04",
    time: "06:30",
    landlordName: "Sarah Johnson",
    contactInfo: "sarah.john@example.com / (555) 123-454255",
    status: "in_progress",
    relatedUnit: "+256 701 234 567",
    subject: "Tenant Lease Violation",
    submitDate: "4/5/2025, 4:00:00 PM",
    landlordDate: "6/5/2025, 4:00:00 AM",
    requestType: "legal",
    contact: { email: "sarah.joh@example.com", phone: "(555) 123-4567" },
    unitId: "APT-1032",
    tenantName: "Michael Smith",
    description:
      "One of my tenants is consistently violating the noise restrictions in their lease agreement. I've issued two warnings already and would like advice on next steps. The violations typically occur after 11 PM on weekends. I have documented complaints from neighboring units as well.",
  },
]